import { baseUrl } from "../../../boot";
import axios from "axios";

export const addTableMaster = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}tableMaster/api/v1/create-Table-Master`,
      formData,
      { headers: { "auth-token": token } }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTableMasterList = async ( payload ={page:1 , search:[]}) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}tableMaster/api/v1/get-Table-Master-List`,

payload,

      { headers: { "auth-token": token } }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTableMasterDetailById = async (id) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(
      `${baseUrl}tableMaster/api/v1/get-Table-Master-ById/${id}`,
      { headers: { "auth-token": token } }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateTableMaster = async (ROWID, data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(
      `${baseUrl}tableMaster/api/v1/update-Table-Master/${ROWID}`,
      data,
      { headers: { "auth-token": token } }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// export const deleteTableMaster = async (ROWID) => {
//   const token = localStorage.getItem("authToken");
//   try {
//     const response = await axios.delete(
//       `${baseUrl}tableMaster/api/v1/delete-Table-Master`,
//       {
//         headers: { "auth-token": token },
//         data: { id: ROWID },
//       }
//     );
//     return response;
//   } catch (error) {
//     throw error;
//   }
// };
export const deleteTableMaster = async (ROWID) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(
      `${baseUrl}tableMaster/api/v1/delete-Table-Master`,
      {
        headers: { "auth-token": token },
        data: { id: [ROWID] },  // ← ROWID ko array mein wrap karo
      }
    );    
    return response;
  } catch (error) {
    throw error;
  }
};

export const countTableMaster = async () => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(
      `${baseUrl}tableMaster/api/v1/get-Table-MasterCount`,
      { headers: { "auth-token": token } }
    );
    return response;
  } catch (error) {
    throw error;
  }
};